import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IFilterButtonProps extends IAppButtonProps {
    iconcolor?:
    | "inherit"
    | "action"
    | "disabled"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | null;
}

export const FilterButton = (props: IFilterButtonProps) => (
    <AppButton
        variant="text"
        color="inherit"
        startIcon={<FilterAltOutlinedIcon color={props.iconcolor} />}
        {...props}
    >
        {props.children}
    </AppButton>
);